const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function logErrorToBackend({ tipo, endpoint, error, usuario, datos, url }) {
  try {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', `${BACKEND_URL}/api/admin/log-error`, true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(JSON.stringify({
      tipo: tipo || 'frontend_error',
      endpoint: endpoint || '',
      error: typeof error === 'string' ? error : (error?.message || String(error)),
      usuario: usuario || {},
      datos: datos || {},
      url: url || window.location.href,
      user_agent: navigator.userAgent
    }));
  } catch (e) {
    // Silently fail - don't break the app for logging
  }
}
